<template>
	<div style="padding-top: 1.43rem;background-image: url(https://imgtest.togy.com.cn/oyjj/langGuo/SOLUTION.jpg);background-size: cover;">
		<div class="big-title">{{$store.state.language == 'EN' ? 'Solution':'解决方案'}}</div>
		<!-- <div class="big-title">解决方案</div> -->

		<div class="switch-box mb-30" @mouseenter="stop()" @mouseleave="pay()">
			<div
				class="switch-item"
				:class="{ 'switch-active': i == head_index, 'switch-phone-item fs-18': is_phone,'fs-20':!is_phone }"
				v-for="(v, i) in head_list"
				:key="i"
				@click="
					head_index = i;
					current = 0;
				"
			>
				{{ v.title }}
			</div>
		</div>

		<!-- <switch-bar ref="switchBar" class="ptb-30" :list="head_list" v-model="head_index" rangeKey="title"></switch-bar> -->

		<div>
			<div :class="is_phone ? 'content bg-w mt-10' : 'flex-c bg-w mt-10'">
				<div v-for="(v, i) in head_list" :key="i">
					<div
						v-show="i == head_index && ind == current"
						class="solution-img tran-time"
						v-for="(val, ind) in v.childrenList"
						:key="ind"
						:style="`background-image: url(${head_list[head_index].childrenList[current].img});`"
					></div>
				</div>

				<div class="flex1" :class="is_phone ? 'pl-20 pb-50' : 'prl-150'" @mouseenter="stop()" @mouseleave="pay()">
					<div v-for="(item, index) in head_list" :key="index" v-show="head_index == index">
						<div class="pt-35" :class="{ 'pb-30': current != i }" v-for="(v, i) in item.childrenList" :key="i" @mouseenter="setIndex(i)">
							<div class="title fs-18" :class="{ 'title-active': i == current }">{{ v.title }}</div>

							<div class="over-hi tran-time" :style="`height:${i == current ? v.height : '0'}px;`">
								<div class="pt-25" :id="index + 'solution' + i">
									<div class="fs-14 lh-24 co-6 mb-10">{{ v.info }}</div>
									<read-more :url="v.url"></read-more>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			head_list: [{}],
			head_index: 0,
			current: 0,
			timer: null
		};
	},
	created() {
		this.$get({
			url: 'app/getSolutionList',
			success: res => {
				this.head_list = res.list.map(v => {
					v.childrenList = v.childrenList.map(val => {
						// 将每个子子项的高度设置为0；如果这里不增加这个参数，后面才增加，再次修改时不会引起页面更新；所以需要在第一个设置时就把这个参数加上；
						val.height = 0;
						return val;
					});
					// 设置当前项是否已经获取了高度，避免一轮过后还继续获取高度
					v.get_height = false;
					return v;
				});
				// 更新完数据先获取一次，后面的监听变化后获取
				this.getHeight();
			}
		});
	},
	beforeDestroy() {},
	watch: {
		// 监听显示项的变化，继续获取高度，因为不显示时获取到的高度是0,所以要显示时才能获取；
		head_index(n, i) {
			this.getHeight();
		},
		// 窗口变化需要重新获取
		win_size() {
			this.head_list = this.head_list.map(v => {
				v.get_height = false;
				return v;
			});
			this.getHeight();
		}
	},
	methods: {
		// 获取元素高度，用于下拉动画
		getHeight() {
			let value = this.head_list[this.head_index];
			if (value.get_height) return;
			setTimeout(() => {
				value.get_height = true;
				value.childrenList = value.childrenList.map((v, i) => {
					v.height = document.getElementById(this.head_index + 'solution' + i).offsetHeight;
					return v;
				});
				this.head_list[this.head_index] = value;
			}, 100);
		},
		// 选中下标
		setIndex(i) {
			clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				this.current = i;
			}, 200);
		},
		// 自动切换
		pay() {
			if (this.head_list.length == 0) return;
			this.timer = setInterval(() => {
				if (this.current == this.head_list[this.head_index].childrenList.length - 1) {
					if (this.head_index == this.head_list.length - 1) this.head_index = 0;
					else this.head_index += 1;
					this.current = 0;
				} else {
					this.current += 1;
				}
			}, 5000);
		},
		stop(text = '外部暂停') {
			this.$debug && console.log(text);
			this.timer && clearInterval(this.timer);
		},
		// 点击切换
		clickItem(i) {
			this.$emit('input', i);
			this.stop('切换暂停');
		}
	}
};
</script>

<style scoped="scoped">
.title {
	color: #a6a6a6;
	display: flex;
	align-items: center;
	position: relative;
}
.title::before {
	content: '';
	display: inline-block;
	width: 0.08rem;
	height: 0.08rem;
	border-radius: 50%;
	background-color: #a6a6a6;
	position: absolute;
	left: -0.15rem;
}
.title:hover::before,
.title-active::before {
	background-color: #d7191c;
}
.title:hover,
.title-active {
	font-weight: bold;
	color: #000000;
}

.bg-text {
	color: #f9fafa;
	font-size: 3.9rem;
	line-height: 3.6rem;
	font-weight: bold;
	text-align: center;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	z-index: -1;
}
.solution-img {
	position: relative;
	width: 11.17rem;
	height: 6.34rem;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	max-width: 100%;
}
.solution-img::after {
	content: '';
	display: block;
	position: absolute;
	top: 0;
	right: 0;
	width: 0;
	height: 0;
	border-style: solid;
	border-color: #fff #fff transparent transparent;
	border-width: 0.1rem;
}

/* 切换栏 */
.switch-box {
	display: flex;
	align-items: center;
	justify-content: center;
}
.switch-item {
	color: #666666;
	padding: 0 0.6rem;
	border-left: 1px solid #cfcfcf;
	cursor: pointer;
	transition: all 0.5s;
}
.switch-item:nth-child(1) {
	border-left: none;
}
.switch-phone-item {
	flex: 1;
	text-align: center;
	padding: 0;
}
.switch-active {
	color: #000000;
	font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/solution.vue